import styled from 'styled-components';
import AbstractTextElement from 'UIComponents/elements/AbstractTextElement';
/**
 * @deprecated use marketplace-ui-common
 */

const BigText = styled(AbstractTextElement).withConfig({
  displayName: "BigText",
  componentId: "bac075-0"
})(["&&{font-size:16px;line-height:28px;}"]);
export default BigText;